import { render, staticRenderFns } from "./OfflineSyncStatus.vue?vue&type=template&id=0e778d12&scoped=true&"
import script from "./OfflineSyncStatus.vue?vue&type=script&lang=js&"
export * from "./OfflineSyncStatus.vue?vue&type=script&lang=js&"
import style0 from "./OfflineSyncStatus.vue?vue&type=style&index=0&id=0e778d12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e778d12",
  null
  
)

export default component.exports